export default "__VITE_ASSET__5xf83xxE__"